export default __webpack_public_path__ + "static/media/c73b47dec549fd8a9378782d5b5d0ee4.png";